import {
  AttachmentValue,
  Entity,
  EntityModel,
  FieldDefinition,
  FormModel,
  ListValue,
  readEntityModelByName,
  readEntityModelIncludeExternal,
  StringFieldDefinition,
  ViewColumnDefinition,
  ViewModel,
} from '@msdk/definitions'

export function mapEntity(entity: Entity, entityModel: EntityModel, formModel?: FormModel): Entity {
  const fields = Object.keys(entity.fields)
  fields.forEach((fieldName) => {
    const fieldValue = entity.fields[fieldName]
    let fieldDef = entityModel.getFieldDefinition(fieldName)

    if (!fieldDef && entity.entityName === 'FORM_ENTITY' && !!formModel) {
      fieldDef = formModel.fields.find((f) => f.name === fieldName) as FieldDefinition
    } else if (!fieldDef) {
      const model = readEntityModelByName(entity.entityName)
      fieldDef = model?.getFieldDefinition(fieldName) as FieldDefinition
    }

    if (fieldDef) {
      const fieldValueInstance = fieldDef.getFieldValue(fieldValue)
      if (fieldValue) fieldValueInstance.mapField(fieldValue, fieldDef)
      entity.fields[fieldName] = fieldValue ? fieldValueInstance : null
    } else {
      // eslint-disable-next-line no-console
      console.groupCollapsed('Map entity field not found')
      console.error('Entity: ' + entity.entityName)
      console.error('Entity ID: ' + entity.id)
      console.error('FieldDefinition undefined! ' + fieldName)
      // eslint-disable-next-line no-console
      console.groupEnd()
    }
  })
  return entity
}

export function mapViewRow(row: Entity, entityModel: EntityModel, viewModel: ViewModel, msProvider?: string): Entity {
  const fields = Object.keys(row.fields)
  fields.forEach((fieldName) => {
    const fieldValue = row.fields[fieldName]
    const column = viewModel.columns.find((c) => c.fieldName === fieldName) as ViewColumnDefinition
    let fieldDef = column?.inlineDefinition ?? entityModel.getFieldDefinition(fieldName)

    if (!fieldDef && fieldName.includes('.')) {
      const alias = viewModel.getTableAliasForColumn(fieldName)
      const join = viewModel.joins.find((j) => j.as === alias)
      const model = msProvider
        ? readEntityModelIncludeExternal(join?.entity as string, msProvider)
        : readEntityModelByName(join?.entity as string)
      fieldDef = model?.getFieldDefinition(viewModel.getFieldNameForColumn(fieldName)) as FieldDefinition
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!fieldDef) fieldDef = new StringFieldDefinition({} as any)
    }

    if (fieldDef) {
      const fieldValueInstance = fieldDef.getFieldValue(fieldValue)
      if (fieldValue) fieldValueInstance.mapField(fieldValue, fieldDef)
      row.fields[fieldName] = fieldValue ? fieldValueInstance : null
    } else {
      // eslint-disable-next-line no-console
      console.groupCollapsed('Map view row field not found')
      console.error('Entity: ' + row.entityName)
      console.error('Entity ID: ' + row.id)
      console.error('FieldDefinition undefined! ' + fieldName)
      // eslint-disable-next-line no-console
      console.groupEnd()
    }
  })
  return row
}

export function mapEntities(entities: Entity[], entityModel: EntityModel): Entity[] {
  return entities.map((e) => mapEntity(e, entityModel))
}

export function mapFilesOnMultipartForm(entities: Entity[], entityModel: EntityModel, data: FormData) {
  entities.forEach((e) => {
    Object.keys(e.fields).forEach((f) => {
      const value = e.fields[f]
      if (value instanceof AttachmentValue && value.file) {
        // The multipart key must match the entity name used by the server binder.
        // Form customization attachments live on FORM_ENTITY, not on the main model,
        // so we need the name of the current one, not the main model
        const k = `${e.entityName}.${e.id}.${f}`
        data.append(k, value.file)
      } else if (value instanceof ListValue) {
        mapFilesOnMultipartForm(value.value as Entity[], entityModel, data)
      }
    })
  })
}
